export const DesktopLg = 1472
export const Desktop = 1280
export const TabletLand = 1120
export const Tablet = 800
export const Phone = 480
export const PhoneSm = 384